import reducerRegistry from '../../reducers/ReducerRegistry';
import { toastsReducer } from './reducers';

export { addToast, deleteToast, clearToasts } from './actions';
export { toastsSelector } from './selectors';

reducerRegistry.register({
    toasts: toastsReducer,
});
